import { render } from "./Hswiper.vue?vue&type=template&id=60461f52&scoped=true"
import script from "./Hswiper.vue?vue&type=script&lang=js"
export * from "./Hswiper.vue?vue&type=script&lang=js"

import "./Hswiper.vue?vue&type=style&index=0&id=60461f52&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60461f52"]])

export default __exports__